import { Calendar, Clock, Video } from "lucide-react";
import { Reveal } from "./Reveal";
import { useBooking } from "@/components/booking/BookingContext";

export default function BookConsult() {
  const { openBooking } = useBooking();

  const points = [
    { Icon: Calendar, label: "Monday–Thursday" },
    { Icon: Clock, label: "9:00 AM–4:00 PM ET" },
    { Icon: Video, label: "30-minute call" },
  ];

  return (
    <section
      id="book"
      data-testid="book-consult-section"
      className="py-24 md:py-36"
      style={{ backgroundColor: "var(--mocha-brown)" }}
    >
      <div className="mx-auto max-w-[1100px] px-6 md:px-10 text-center">
        <Reveal>
          <p
            className="text-sm tracking-[0.28em] uppercase mb-6"
            style={{ color: "var(--accent-gold-soft)" }}
          >
            Let's begin
          </p>
          <h2
            className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-7"
            style={{ color: "#FBF6F3" }}
          >
            Book a complimentary
            <span className="block italic" style={{ color: "var(--accent-gold-soft)" }}>
              discovery call
            </span>
          </h2>
          <p
            className="text-base md:text-lg leading-relaxed max-w-xl mx-auto mb-10"
            style={{ color: "#E7D2CC" }}
          >
            A relaxed 30-minute conversation to understand your world, your goals, and how
            I can take the busywork off your plate.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 mb-12">
            {points.map(({ Icon, label }) => (
              <div key={label} className="flex items-center gap-2.5" style={{ color: "#E7D2CC" }}>
                <Icon size={18} color="var(--accent-gold-soft)" />
                <span className="text-sm md:text-base">{label}</span>
              </div>
            ))}
          </div>

          <button
            onClick={openBooking}
            data-testid="book-consult-cta"
            className="inline-flex items-center rounded-full px-10 py-4 text-sm font-medium transition-transform duration-300 hover:-translate-y-0.5"
            style={{ backgroundColor: "var(--accent-gold)", color: "#2E241D" }}
          >
            Choose your time
          </button>
        </Reveal>
      </div>
    </section>
  );
}
